/**
 * PKCE (RFC 7636) helpers for the one-fiit authorization-code flow.
 *
 * Ported from one-fiit's `packages/auth-utils/src/utils/accessFastPath.ts`, where they are
 * module-private, so the two implementations must stay byte-compatible: one-fiit-api hashes
 * the verifier the same way when it validates the exchange.
 */

const toBase64Url = (bytes: Uint8Array): string =>
  btoa(String.fromCharCode.apply(null, Array.from(bytes)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

export const generateCodeVerifier = (): string => {
  const randomBytes = new Uint8Array(32);
  crypto.getRandomValues(randomBytes);

  return toBase64Url(randomBytes);
};

export const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));

  return toBase64Url(new Uint8Array(digest));
};

export const CODE_CHALLENGE_METHOD = 'S256';
